import { handleActions } from 'redux-actions';
import { LegsAction, SET_LEGS } from './actions';
import { Leg } from '../../types';

export const legsReducer = handleActions(
	{
		[SET_LEGS]: (state: Leg[], action: LegsAction) => action.payload
	},
	[]
);
